import { useState, useRef } from "react";
import { useCookies } from "react-cookie";
import { Formik, Form as FormikForm, Field } from "formik";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setLoading } from "../../../../store/slices/loaderSlice";
import * as yup from "yup";
import {
  confimationStyles,
  errorStyles,
} from "../../../../assets/styles/toast";
import { expirationTime } from "../../../../helpers/expirationTime";
// import { postData } from "../../../../services";
// import { setLoading } from "../../../../store/slices/loaderSlice";
import Error from "../../../atoms/Error";
// import PasswordField from "../../../atoms/PasswordField";
// import styles from "../forms.module.scss";
import { numberToNumeric } from "../../../../helpers/numberToNumeric";
import { postData } from "../../../../services";
import TextInput from "../../../atoms/TextInput";
import PasswordField from "../../../atoms/TextInput/PasswordField";
import Mail from '../../../icons/Mail'
import CheckBox from '../../../atoms/Checkbox'

const Form = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [passwordValue, setPasswordValue] = useState(false);
  const passwordRef = useRef(null);
  const [cookie, setCookie] = useCookies(["euid", "email", "role","eut" , "emp_id"]);
  const [pageError, setPageError] = useState(undefined);

  const initialValues = {
    email: "",
    password: "",
  };

  const validationSchema = yup.object().shape({
    email: yup
      .string()
      .email("Invalid email address")
      .required("Email is required"),
    password: yup.string().required("Password is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const lowercaseEmail = values.email.toLowerCase();
      const updatedValues = { ...values, email: lowercaseEmail };
      dispatch(setLoading(true));
      const { data: resultData } = await postData({
        endpoint: "Auth/employeeLogin",
        data: {},
        params: updatedValues,
      });

      if (resultData.status && resultData.statusCode === 200) {
        dispatch(setLoading(false));
        setCookie("euid", resultData.data.user_id, {
          path: "/",
          expires: expirationTime(),
          // secure: true,
        });
        setCookie("eml", resultData.data.email, {
          path: "/",
          expires: expirationTime(),
          // secure: true,
        });
        setCookie("eut", resultData.data.user_type, {
          path: "/",
          expires: expirationTime(),
          // secure: true,
        });
        localStorage.setItem("countdownStartTime", "30");
        navigate("/auth/verify");
        toast.success(resultData.message, {
          duration: 1000,
          style: confimationStyles,
        });
      } else {
        toast.error(resultData.message, {
          duration: 1000,
          style: errorStyles,
        });
        if (resultData.response === 401) {
          if (resultData?.data?.limit_left > 0) {
            const triesLeft = numberToNumeric[resultData?.data?.limit_left];
            setPageError(
              `You've only ${triesLeft} tr${
                resultData?.data?.limit_left === 1 ? "y" : "ies"
              } remaining`
            );
          } else if (resultData?.data?.limit_left === 0) {
            setPageError("No attempts left");
          } else {
            setPageError(undefined);
          }
        } else {
          setPageError(undefined);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
      toast.error("Error Occured", {
        duration: 1000,
        style: errorStyles,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      validateOnChange
      validateOnBlur
    >
      {({
        isValid,
        dirty,
        handleSubmit,
        isSubmitting,
        touched,
        errors,
        values,
        setFieldValue,
        setFieldTouched,
        handleBlur,
      }) => (
        <FormikForm onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>

            <TextInput
              name="email"
              type="text"
              className="primary-input"
              placeholder="Enter Email"
              customholder="Enter Email"
              autoComplete="off"
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\s/g, '');
              }}
              icon={<Mail/>}
              InputHeight="large"
            />
          </div>

          <div className="form-group mt-4">
            <PasswordField
              label="Password"
              id="password"
              name="password"
              value={values.password}
              onChange={(e) => setFieldValue("password", e.target.value)}
              onBlur={handleBlur}
              placeholder="Enter your Password"
              className={`${
                (touched.password || isSubmitting) && errors.password
                  ? "error-input"
                  : ""
              }`}
            />
            {(touched.password || isSubmitting) && errors.password && (
              <Error error={errors.password} />
            )}
          </div>

          {pageError && <Error error={pageError} />}

          <div className="mt-4 mb-20 d-flex align-items-center justify-content-end">
{/* 
          <CheckBox name="acceptedTerms">Remember Me</CheckBox> */}

            <a href="/auth/forgot-password"> Forgot Password?</a>
          </div>

          <button
            className="auth_btn btn-primary w-100"
            type="submit"
            disabled={isSubmitting}
          >
            Log In
    
            {isSubmitting && (
              <span
                className="spinner-border spinner-border-sm ms-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
          </button>

          <button className="auth_btn btn-outline-primary w-100 mt-3" type="button" onClick={() => navigate('/auth/request-otp')}>
            Login with OTP
          </button>

      
        </FormikForm>
      )}
    </Formik>
  );
};

export default Form;
